import * as React from 'react'

import {
  spacing,
  styled,
  Text,
  TextEntry,
  TextStyle,
} from '@thg-commerce/gravity-theme'
import { SafeHtml } from '@thg-commerce/gravity-elements'

const Container = styled.div`
  display: block;
  margin-bottom: ${spacing(1)};
`

export const StyledSafeHtml = styled(SafeHtml)<{
  textStyle?: { entry: TextEntry; style: TextStyle }
}>`
  &,
  a {
    ${(props) =>
      Text(
        props.textStyle?.entry || 'bodyText',
        props.textStyle?.style || 'alternate',
      )}
  }
`

const Title = styled.h2`
  ${Text('medium1', 'alternate')}
  margin: ${spacing(1)} 0 ${spacing(1)};
`

interface InformationSectionProps {
  title?: string
  children: React.ReactNode
  hideTitle?: boolean
}

const InformationSection = ({ ...props }: InformationSectionProps) => {
  return (
    <Container>
      {props.title && !props.hideTitle && <Title>{props.title}</Title>}

      {props.children}
    </Container>
  )
}

export default InformationSection
